import { createFileRoute } from "@tanstack/react-router";

import { KanzleilandIntegrationsContainer } from "@/features/settings/kanzleiland";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings/einstellungen/kanzleiland",
)({
  component: Forwarding,
});

function Forwarding() {
  return <KanzleilandIntegrationsContainer />;
}
